import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Rolar o mouse em cima de um campo numérico selecionado não altera mais o valor:
// o campo perde o foco e a rolagem segue para a página.
document.addEventListener('wheel', (e) => {
  const el = document.activeElement;
  if (el && el.type === 'number' && el === e.target) el.blur();
}, { passive: true });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
